<template>
    <rkm-modal
        extra-large
        ref="RkmModal"
        title="Protocolos"
    >
        <rkm-area
            v-if="!data.additionals.oci.hasOciAtivada"
            title="Busca"
            type="fieldset"
        >
            <rkm-form ref="Form">
                <rkm-row>
                    <rkm-col cols="6">
                        <rkm-form-input
                            :validations="validations.nome"
                            label="Nome"
                            v-model="model.nome"
                        />
                    </rkm-col>

                    <rkm-col>
                        <rkm-form-input
                            :validations="validations.linhaCuidado"
                            label="Linha de cuidado"
                            v-model="model.linhaCuidado"
                        />
                    </rkm-col>

                    <rkm-col cols="auto">
                        <rkm-button
                            :label="false"
                            @click="$refs.Form.validate(search)"
                            color="primary"
                        >
                            Buscar
                        </rkm-button>

                        <rkm-button
                            :label="false"
                            @click="reset"
                        >
                            Limpar
                        </rkm-button>
                    </rkm-col>
                </rkm-row>
            </rkm-form>

            <rkm-table
                :fields="fieldsBusca"
                :items="ocis"
                hide-filters
            >
                <template v-slot:cell(actions)="{ item }">
                    <rkm-button
                        :disabled="!!data.model.oci"
                        @click="ativarOci(item.id)"
                        color="primary"
                        small
                        title="Ativar protocolo"
                    >
                        <rkm-icon icon="check" />
                    </rkm-button>
                </template>
            </rkm-table>
        </rkm-area>

        <rkm-area
            title="Protocolo em andamento"
            type="fieldset"
        >
            <rkm-table
                :fields="fieldsProtocoloAtivado"
                :items="ocisAtivadas"
                hide-filters
                hide-pagination
            >
                <template v-slot:cell(actions)>
                    <rkm-button
                        v-if="data.additionals.oci.hasOciAtivada"
                        @click="$refs.ModalDetalhe.open()"
                        color="primary"
                        small
                        title="Detalhes"
                    >
                        <rkm-icon icon="bars" />
                    </rkm-button>

                    <rkm-button
                        :disabled="data.additionals.oci.hasOciAtivada"
                        @click="excluirOci"
                        color="danger"
                        small
                        title="Excluir"
                    >
                        <rkm-icon icon="trash" />
                    </rkm-button>
                </template>
            </rkm-table>
        </rkm-area>

        <template v-slot:footer="{cancel}">
            <rkm-button @click="cancel">
                Fechar
            </rkm-button>
        </template>

        <ModalDetalhe
            v-if="data.additionals.oci.hasOciAtivada"
            :data="data"
            ref="ModalDetalhe"
        />
    </rkm-modal>
</template>

<script>
// Components.
import ModalDetalhe from './components/detalhe/Modal'

// Mixins.
import { repository, error } from '@/mixins'

// Vuex.
import { mapActions } from 'vuex'

export default {
    components: { ModalDetalhe },
    computed: {
        validations() {

            return {
                nome: { required: !this.model.linhaCuidado },
                linhaCuidado: { required: !this.model.nome },
            }
        },
        ocisAtivadas() {

            if (!this.data.model.oci) {

                return []
            }

            return [this.data.model.oci]
        }
    },
    created() {

        this.repositories = {
            atendimento: this.getConectaSusRepository('ambulatorio.atendimento'),
        }
    },
    data: () => ({
        model: {
            nome: null,
            linhaCuidado: null,
        },
        ocis: [],
        fieldsBusca: [
            { key: 'nome', label: 'Nome', sortable: true },
            { key: 'linhaCuidado', label: 'Linha de cuidado', sortable: true },
            { key: 'actions', label: 'Ações', class: 'col-min text-center' },
        ],
        fieldsProtocoloAtivado: [
            { key: 'nome', label: 'Nome' },
            { key: 'linhaCuidado', label: 'Linha de cuidado' },
            { key: 'etapaClinicaAtualNome', label: 'Etapa clínica atual' },
            { key: 'actions', label: 'Ações', class: 'col-min text-center' },
        ]
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        open() {

            if (!this.data.additionals.oci.hasOciAtivada) {

                this.reset()

                this.ocis = []
            }

            this.$refs.RkmModal.show()
        },
        search() {

            this.setLoading()

            this.repositories.atendimento.list({
                origem: 'protocolos',
                listar: 'ocis',
                nome: this.model.nome,
                linha_cuidado: this.model.linhaCuidado,
            })
                .then(({ data }) => this.ocis = data)
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        reset() {

            this.model.nome = null
            this.model.linhaCuidado = null

            this.$nextTick().then(() => this.$refs.Form.resetValidator())
        },
        ativarOci(id) {

            this.setLoading()

            this.repositories.atendimento.getOci(id)
                .then(({ data }) => {

                    this.data.model.oci = data
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        excluirOci() {

            this.showDeleteConfirmation(
                'Tem certeza que deseja excluir o protocolo ativado?',
                async () => this.data.model.oci = null
            )
        }
    },
    mixins: [repository, error],
    props: {
        data: {type: Object, required: true},
    },
}
</script>